module.exports = __webpack_public_path__ + "img/3.a78da0f1.jpg";